import { all, takeLatest, call, put } from 'redux-saga/effects';
import { Url } from '@wix/da-url';
import { isApiError, requestPuppy } from '@wix/da-http-client';
import { setCompliantLocalStorageItem } from '../../redux/compliantLocalStorage/actions';
import { CompliantLocalStorageKeys } from '../../redux/compliantLocalStorage/constants';
import { setSocialLoginError, attemptSocialLogin, socialLoginSuccess } from './actions';
function* handleLogin(action) {
    const { provider, token, redirectToJoin, redirectToSisu } = action.payload;
    const response = yield call(requestPuppy, {
        method: 'post',
        url: '/signin_social',
        data: {
            provider,
            provider_token: token,
            remember: true
        }
    }, undefined, 'dasignupsignin');
    if (!response || isApiError(response)) {
        yield put(setSocialLoginError('general'));
        return;
    }
    var _response_errors;
    const errors = (_response_errors = response.errors) !== null && _response_errors !== void 0 ? _response_errors : [];
    if (!response.success || errors.length > 0) {
        const errorKey = errors.length > 0 ? errors[0] : '';
        yield put(setSocialLoginError(errorKey));
        return;
    }
    yield put(setSocialLoginError(undefined));
    if (redirectToSisu) {
        if (response.loggedin) {
            window.location.assign(Url.browseHomeLink());
            return;
        }
        var _response_tokenId;
        yield put(setCompliantLocalStorageItem({
            key: CompliantLocalStorageKeys.SOCIAL,
            value: `${provider}:${(_response_tokenId = response.tokenId) !== null && _response_tokenId !== void 0 ? _response_tokenId : ''}`
        }));
        window.location.assign(Url.joinLink());
        return;
    }
    yield put(socialLoginSuccess({
        provider,
        response,
        redirectToJoin
    }));
}
export default function* socialSaga() {
    yield all([
        takeLatest(attemptSocialLogin, handleLogin)
    ]);
}

//# sourceMappingURL=saga.js.map